var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5083 9.34998V13.0916C2.5083 16.8333 4.0083 18.3333 7.74997 18.3333H12.2416C15.9833 18.3333 17.4833 16.8333 17.4833 13.0916V9.34998",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 9.99996C11.525 9.99996 12.65 8.75829 12.5 7.23329L11.95 1.66663H8.05832L7.49999 7.23329C7.34999 8.75829 8.47499 9.99996 9.99999 9.99996Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2583 9.99996C16.9416 9.99996 18.175 8.63329 18.0083 6.95829L17.775 4.66663C17.475 2.49996 16.6416 1.66663 14.4583 1.66663H11.9166L12.5 7.50829C12.6416 8.88329 13.8833 9.99996 15.2583 9.99996Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70002 9.99996C6.07502 9.99996 7.31669 8.88329 7.45002 7.50829L7.63336 5.66663L8.03336 1.66663H5.49169C3.30836 1.66663 2.47502 2.49996 2.17502 4.66663L1.95002 6.95829C1.78336 8.63329 3.01669 9.99996 4.70002 9.99996Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 14.1666C8.60829 14.1666 7.91663 14.8583 7.91663 16.25V18.3333H12.0833V16.25C12.0833 14.8583 11.3916 14.1666 9.99996 14.1666Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseIcon);
export default __webpack_public_path__ + "static/media/WarehouseIcon.ecc542873fcda15cdd8410b86049aeba.svg";
export { ForwardRef as ReactComponent };